<app-menu-common url="sales"></app-menu-common>

<div class="invoice-creation-container">
  <!-- Top Page Header & Title Row -->
  <div class="pageheader flexcolumn">
    <div class="header-title-row">
      <div class="pagetitle-wrapper">
        <mat-icon class="pagetitle-icon">post_add</mat-icon>
        <div>
          <div class="pagetitle grey">Facturation des Bons de Livraison</div>
          <div class="pagesubtitle text-muted">Regroupement et émission des factures clients à partir des livraisons (BOFIP ISCA)</div>
        </div>
      </div>
      <span class="spacer"></span>
      <div class="header-actions">
        <a mat-stroked-button color="primary" routerLink="/sales/invoices" class="action-btn" matTooltip="Consulter les factures clients">
          <mat-icon>receipt_long</mat-icon>
          Factures Clients
        </a>
        <a mat-stroked-button color="primary" routerLink="/sales/bank-lettering" class="action-btn" matTooltip="Ouvrir le lettrage bancaire">
          <mat-icon>account_balance</mat-icon>
          Rapprochement Bancaire
        </a>
        <button mat-stroked-button color="primary" class="action-btn" (click)="loadData()" [disabled]="loading" matTooltip="Rafraîchir les bons de livraison">
          <mat-icon [class.spinning]="loading">refresh</mat-icon>
          Actualiser
        </button>
      </div>
    </div>

    <!-- Toolbar / Selection & Action Bar -->
    @if (!loading && datasource && datasource.length > 0) {
      <div class="selection-toolbar">
        <div class="toolbar-info">
          <span class="badge-count">{{ getTotalDeliveriesCount() }} BL à facturer</span>
          @if (selectedDeliveryIds.size > 0) {
            <span class="selected-count">
              ({{ selectedDeliveryIds.size }} sélectionné{{ selectedDeliveryIds.size > 1 ? 's' : '' }})
            </span>
          }
        </div>
        <div class="batch-actions">
          <button mat-button color="primary" (click)="selectAllDeliveries()" [disabled]="getTotalDeliveriesCount() === 0">
            <mat-icon>select_all</mat-icon>
            Tout sélectionner
          </button>
          <button mat-button (click)="deselectAllDeliveries()" [disabled]="selectedDeliveryIds.size === 0">
            <mat-icon>deselect</mat-icon>
            Désélectionner
          </button>
        </div>
        <span class="spacer"></span>
        <app-action-bar [hassave]="false">
          @if (true) {
            <app-invoice-creation-action (submitEmitter)="onActionBarAction($event)"></app-invoice-creation-action>
          }
        </app-action-bar>
      </div>
    }
  </div>

  <!-- Loading State -->
  @if (loading) {
    <div class="loading-state">
      <div class="spinner"></div>
      <span>Chargement des bons de livraison à facturer...</span>
    </div>
  }

  <!-- Empty State -->
  @if (!loading && (!datasource || datasource.length === 0)) {
    <div class="empty-state">
      <mat-icon class="empty-icon">task_alt</mat-icon>
      <div class="empty-title">Aucun bon de livraison en attente</div>
      <div class="empty-desc">Toutes les livraisons éligibles ont été facturées. Les nouvelles livraisons validées apparaîtront ici automatiquement.</div>
      <button mat-stroked-button color="primary" (click)="loadData()" style="margin-top: 16px;">
        <mat-icon>refresh</mat-icon>
        Vérifier à nouveau
      </button>
    </div>
  }

  <!-- Content List: Grouped by Billing Address / Customer -->
  @if (!loading && datasource && datasource.length > 0) {
    @for (add of datasource; track add) {
      <div class="customer-card">
        <!-- Customer Header -->
        <div class="customer-header">
          <div class="customer-info">
            <mat-icon class="customer-icon">person</mat-icon>
            <div>
              <div class="customer-name">{{ add.lnk_customer.firstname }} {{ add.lnk_customer.name }}</div>
              @if (add.lnk_addr_bill.id !== 0) {
                <div class="customer-address">
                  <mat-icon class="address-icon">location_on</mat-icon>
                  <span>{{ add.lnk_addr_bill.street1 }} {{ add.lnk_addr_bill.zip }} {{ add.lnk_addr_bill.city }}</span>
                </div>
              } @else {
                <div class="missing-address-alert">
                  <mat-icon>warning</mat-icon>
                  <span>Adresse de facturation non spécifiée</span>
                </div>
              }
            </div>
          </div>
          <div class="customer-badge">
            {{ add.lnk_deliveries ? add.lnk_deliveries.length : 0 }} BL
          </div>
        </div>
        <!-- Deliveries List -->
        <div class="deliveries-list">
          @for (d of add.lnk_deliveries; track d) {
            <div
              class="delivery-card"
              [class.delivery-selected]="selectedDeliveryIds.has(d.id)"
              [class.has-error]="add.lnk_addr_bill.id === 0">
              <div class="delivery-header">
                <div class="delivery-main-info">
                  <mat-checkbox
                    [checked]="selectedDeliveryIds.has(d.id)"
                    (change)="toggleSelection(d.id, $event.checked)"
                    color="primary"
                    class="delivery-checkbox">
                  </mat-checkbox>
                  <div class="delivery-titles">
                    <div class="order-bl-links">
                      <a [routerLink]="['/sales/quotation/', d.id_order]" class="link-order" matTooltip="Consulter la commande">
                        <mat-icon>shopping_bag</mat-icon>
                        Commande #{{ d.id_order }}
                      </a>
                      <span class="badge-bl">
                        <mat-icon>local_shipping</mat-icon>
                        BL #{{ d.id }}
                      </span>
                    </div>
                    @if (d.lnk_order?.lnk_partner_deliv) {
                      <div class="delivery-address">
                        <span class="text-muted">Livraison :</span>
                        <span>{{ d.lnk_order?.lnk_partner_deliv?.street1 }} {{ d.lnk_order?.lnk_partner_deliv?.zip }} {{ d.lnk_order?.lnk_partner_deliv?.city }}</span>
                      </div>
                    }
                    @if (d.lnk_order) {
                      <div class="delivery-date">
                        <span class="text-muted">Validé le :</span>
                        <span>{{ datState(d.lnk_order, 1) | date: 'dd/MM/yyyy HH:mm' }}</span>
                      </div>
                    }
                  </div>
                </div>
                <div class="delivery-actions">
                  @if (d.lnk_order?.state === SalesOrderState.QUOTE) {
                    <button
                      mat-stroked-button
                      color="primary"
                      (click)="onClickChangeState(d.id, SalesOrderState.QUOTE, SalesOrderState.PREPARATION)"
                      class="state-btn">
                      <mat-icon>local_shipping</mat-icon>
                      Livrer
                    </button>
                  }
                  @if (d.lnk_order?.state === SalesOrderState.PREPARATION) {
                    <button
                      mat-stroked-button
                      color="warn"
                      (click)="onClickChangeState(d.id, SalesOrderState.PREPARATION, SalesOrderState.QUOTE)"
                      class="state-btn">
                      <mat-icon>block</mat-icon>
                      Annuler liv.
                    </button>
                  }
                </div>
              </div>
              <!-- Product Lines Expansion -->
              <mat-accordion class="delivery-lines-accordion">
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <span class="total-ttc-badge">Total : {{ getDeliveryTotal(d) | number:'1.2-2' }} € TTC</span>
                      <span class="spacer"></span>
                      <span class="lines-count">{{ d.lnk_deliveryl ? d.lnk_deliveryl.length : 0 }} ligne(s) d'articles</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="lines-table-wrapper">
                    <table class="lines-table">
                      <thead>
                        <tr>
                          <th class="col-product">Article / Désignation</th>
                          <th class="col-qty text-center">Quantité</th>
                          <th class="col-price text-right">P.U. TTC</th>
                          <th class="col-total text-right">Total TTC</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (l of getDeliveryLines(d); track l) {
                          <tr>
                            <td class="col-product">{{ l.product_name }}</td>
                            <td class="col-qty text-center">{{ l.qty }}</td>
                            <td class="col-price text-right">{{ l.uprice_taxi | number:'1.2-2' }} €</td>
                            <td class="col-total text-right">{{ (l.qty * l.uprice_taxi) | number:'1.2-2' }} €</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          }
        </div>
      </div>
    }
  }
</div>